export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
export const RESET_NOTIFICATION = 'RESET_NOTIFICATION';
export const SET_NOTIFICATION = 'SET_NOTIFICATION';


export const  setNotification  = (length) => ({
  type: SET_NOTIFICATION,
  payload: length,
});

// Action creator for updating notification length
export const updateNotification = (notificationLength) => ({
  type: UPDATE_NOTIFICATION,
  payload: notificationLength, // Fix typo here
});

// Action creator for resetting notification length
export const resetNotification = () => ({
  type: RESET_NOTIFICATION,
});
